<ul class="product-symbols__list" boelsQa="product-symbols-list">
  @for (feature of symbols.features; track feature; let outerIndex = $index) {
    @for (
      symbol of feature.featureValues;
      track symbol;
      let innerIndex = $index
    ) {
      <li>
        @if (feature.code && symbol.code && symbol.value) {
          <img
            class="product-symbols__img"
            loading="lazy"
            [src]="parseSymbolName(feature.code, symbol.code)"
            [alt]="symbol.value"
            [ngbTooltip]="symbol.value"
            [tooltipClass]="'ngb-boels-tooltip'"
            [autoClose]="'inside'"
            container="body"
            data-boundary="viewport"
            tabindex="0"
            role="button"
            [boelsQa]="'product-symbol-' + feature.code + '-' + symbol.code"
          />
        }
      </li>
    }
  }
</ul>
